import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReservationStatusCode } from '../../event/models/reservation-status-code.enum';

@Pipe({
  name: 'reservationStatus'
})
export class ReservationStatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: string, args?: any): any {
    value = value.toUpperCase().toString();

    let returnValue = '';

    switch (value) {
      case 'rsvp':
        returnValue = this.translateService.instant('RESERVATION_STATUS.READY');
        break;
      case ReservationStatusCode.CANCELLED.toString():
        returnValue = this.translateService.instant('RESERVATION_STATUS.CANCELLED');
        break;
      case ReservationStatusCode.CHECKED_IN.toString():
        returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_IN');
        break;
      case ReservationStatusCode.CHECKED_OUT.toString():
        returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_OUT');
        break;
      case ReservationStatusCode.NO_SHOW.toString():
        returnValue = this.translateService.instant('RESERVATION_STATUS.NO_SHOW');
        break;
      case ReservationStatusCode.RESERVED.toString():
        returnValue = this.translateService.instant('RESERVATION_STATUS.RESERVED');
        break;
      default:
        returnValue = this.translateService.instant('RESERVATION_STATUS.UNKNOWN', { key: value });
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/reservation-status.pipe.ts